



(() => {
  window.addEventListener("load", () => {

    const section_logo = document.querySelector(".hero-logo-section img");
    const navbar_logo  = document.querySelector(".logo-image");

    if (!section_logo || !navbar_logo) {
      console.log("Logo element missing");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const end_width = 110; // number rakho

    gsap.fromTo(
      section_logo,
      { width: 270 },       // starting width
      {
        width: end_width,
        ease: "none",
        scrollTrigger: {
          trigger: ".hero-logo-section",
          start: "top top",
          end: "bottom top",
          //scrub: true,
          scrub: 0.3,
          invalidateOnRefresh: true
        }
      }
    );

    ScrollTrigger.refresh();
  });
})();


